// Module
var code = "<popover v-if=\"permissionTooltip[permission]\" @open=\"openPermissionDescription(permission)\" class=\"inline-block\"> <a class=\"pad-left12\" href=\"#\" aria-label=\"Learn about this permission\"> <icon name=\"help_outline\"></icon> </a> </popover>";
// Exports
export default code;